import { render, staticRenderFns } from "./display_sync_data.vue?vue&type=template&id=a7ce7e94&"
import script from "./display_sync_data.vue?vue&type=script&lang=js&"
export * from "./display_sync_data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7ce7e94')) {
      api.createRecord('a7ce7e94', component.options)
    } else {
      api.reload('a7ce7e94', component.options)
    }
    module.hot.accept("./display_sync_data.vue?vue&type=template&id=a7ce7e94&", function () {
      api.rerender('a7ce7e94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/registrations/display_sync_data.vue"
export default component.exports